import { preload } from 'swr';
import useSWRImmutable from 'swr/immutable';
import noErrorFetcher from '../../shared/noErrorFetcher';
import { KEY } from '../constants';

const usePrequal = (options) => (
  useSWRImmutable(KEY, noErrorFetcher, { suspense: true, ...options })
);

preload(KEY, noErrorFetcher);

export default usePrequal;
